import lottie from 'lottie-web';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dotlottie-canvas').forEach((canvas) => {
    const src = canvas.dataset.src;
    const iconWrapper = canvas.closest('.card-icon__card-wrapper');
    const linkElement = iconWrapper?.closest('a');

    const hoverTarget = linkElement || iconWrapper;

    if (!src || !iconWrapper || !hoverTarget) return;

    let isHovered = false;

    const animation = lottie.loadAnimation({
      container: canvas,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: src,
    });

    animation.addEventListener('complete', () => {
      if (isHovered) {
        setTimeout(() => {
          if (isHovered) animation.goToAndPlay(0);
        }, 100);
      }
    });

    hoverTarget.addEventListener('mouseenter', () => {
      isHovered = true;
      animation.goToAndPlay(0);
    });

    hoverTarget.addEventListener('mouseleave', () => {
      isHovered = false;
    });
  });
});
